// @mui
import { TableRow, TableCell, Typography, Button } from '@mui/material';
// types
import { CoverExtra } from '../types';
import { PermissionsObject } from '@/types';

type Props = {
  row: CoverExtra;
  permissions?: PermissionsObject;
  onEditRow: VoidFunction;
  onSelectRow: VoidFunction;
  selected: boolean;
};

export default function TableRowData({
  row,
  permissions,
  onEditRow,
  selected,
}: Props) {
  const { name, extra_type } = row;

  return (
    <TableRow hover selected={selected}>
      <TableCell>
        <Typography variant="subtitle2" noWrap>
          {name}
        </Typography>
      </TableCell>
      <TableCell>
        <Typography variant="subtitle2" noWrap>
          {extra_type.name}
        </Typography>
      </TableCell>

      <TableCell align="right">
        <>
          {permissions?.canUpdate && (
            <Button
              onClick={() => {
                onEditRow();
              }}
              variant="contained"
            >
              Edit
            </Button>
          )}
        </>
      </TableCell>
    </TableRow>
  );
}
